// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/* purgecss start ignore */\n\n/* purgecss end ignore */", "",{"version":3,"sources":["<no source>"],"names":[],"mappings":"AAAA,2BAAA;;AAAA,yBAAA","file":"App.css"}]);
// Exports
module.exports = exports;
